<template>
  <b-navbar>
    <template slot="brand">
      <b-navbar-item tag="router-link" to="/">
        <img src="@/assets/sr-logo-short-50.png" alt="SpeakyReads Logo" />
      </b-navbar-item>
      <b-navbar-item
        v-if="!isDesktop"
        @click="toggleTargetModal"
        title="Daily Target"
      >
        <Target />
      </b-navbar-item>
    </template>
    <template slot="start">
      <b-navbar-item tag="router-link" to="/">
        Home
      </b-navbar-item>
      <b-navbar-item tag="router-link" to="/library">
        Library
      </b-navbar-item>
      <b-navbar-item v-if="oidcUser" tag="router-link" to="/progress">
        Progress
      </b-navbar-item>
      <b-navbar-item
        v-if="isDesktop"
        @click="toggleTargetModal"
        title="Daily Target"
      >
        <Target />
      </b-navbar-item>
    </template>
    <template slot="end">
      <Notifications v-if="oidcUser" />
      <UserMenu />
    </template>
  </b-navbar>
</template>

<script>
import authMixin from "@/mixins/authMixin";
import Target from "./Target";
import Notifications from "./Notifications";
import UserMenu from "./UserMenu";

export default {
  name: "Navbar",
  mixins: [authMixin],
  components: { Target, Notifications, UserMenu },
  computed: {
    isDesktop() {
      return window.innerWidth >= 1024;
    }
  },
  methods: {
    toggleTargetModal() {
      this.$root.$emit("toggleTargetModal");
    }
  }
};
</script>

<style lang="scss" scoped></style>
